type SvgProps = React.SVGProps<SVGSVGElement>;

export const PaperWithCross = (props: SvgProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M8.41273 0H2.92123C2.45711 0 2.01199 0.184374 1.6838 0.512563C1.35561 0.840752 1.17123 1.28587 1.17123 1.75V14H12.8379V4.42517L8.41273 0ZM8.75457 1.9915L10.8464 4.08333H8.75457V1.9915ZM2.3379 12.8333V1.75C2.3379 1.59529 2.39936 1.44692 2.50876 1.33752C2.61815 1.22812 2.76652 1.16667 2.92123 1.16667H7.5879V5.25H11.6712V12.8333H2.3379ZM9.31282 7.26658L7.8294 8.75L9.31282 10.2334L8.48798 11.0583L7.00457 9.57483L5.52115 11.0583L4.69632 10.2334L6.17973 8.75L4.69632 7.26658L5.52115 6.44175L7.00457 7.92517L8.48798 6.44175L9.31282 7.26658Z"
      fill="currentColor"
    />
  </svg>
);

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="5"
  height="9"
  viewBox="0 0 5 9"
  fill="none"
>
  <path
    d="M0.940665 8.94267L0 8L3.52599 4.47133L0 0.942666L0.943332 0L4.46666 3.52867C4.71662 3.7787 4.85704 4.11778 4.85704 4.47133C4.85704 4.82489 4.71662 5.16396 4.46666 5.414L0.940665 8.94267Z"
    fill="#5622FF"
  />
</svg>;
